import React, { useEffect } from "react";
import CardLayout from "../../../components/ReusableComponents/CardLayout";
import DoughnutChart from "../../../components/ReusableComponents/DoughnutChart";
import { ChartCardContent } from "../../dashboard/dashboard.styled";
import { CardWrapper } from "../Apprenticeship.styled";
import { toast } from "react-toastify";
import { fetchChartData } from "../utils";
import ChartlabelALT from "../../../components/ReusableComponents/ChartlabelALT";
import { DoughnutChartOptions } from "../../../Constants";
import { useDispatch, useSelector } from "react-redux";
import { updateChart } from "../ApprenticeshipSlice";

const HeaderCharts = () => {
	/* eslint-disable no-unused-vars */
	const chartInfo = useSelector((state) => state.apprenticeship.chart.info);
	const totalValue = useSelector((state) => state.apprenticeship.chart.totalValue);

	const dispatch = useDispatch();

	const chart1Data = {
		labels: ["Investor", "Apprentice"],
		datasets: [
			{
				label: "user",
				data: [chartInfo.investor, chartInfo.apprentice],
				backgroundColor: ["#00D19F", "#DAE7ED"],
			},
		],
		totalValue: totalValue.chart1,
	};

	const chart2Data = {
		labels: ["Sponsored", "Quick"],
		datasets: [
			{
				label: "A.F",
				data: [chartInfo.sponsored, chartInfo.quick],
				backgroundColor: ["#006770", "#DAE7ED"],
			},
		],
		totalValue: totalValue.chart2,
	};

	useEffect(() => {
		getChartData();
	}, []);

	const getChartData = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
			const chartInfo = await fetchChartData();
			if (chartInfo?.result) {
				let result = {
					info: {
						investor: chartInfo.result?.investor,
						apprentice: chartInfo.result?.apprentice,
						sponsored: chartInfo.result?.sponsored,
						quick: chartInfo.result?.quick,
					},
					totalValue: {
						chart1: chartInfo.result?.investor + chartInfo.result?.apprentice,
						chart2: chartInfo.result?.sponsored + chartInfo.result?.quick,
					},
				};
				dispatch(updateChart(result));
			}
		} catch (error) {
			console.error(error);
			toast.error("unable to fetch lease data");
		}
	};

	return (
		<CardWrapper>
			<CardLayout type='Apprenticeship Finance'>
				<ChartCardContent firstcolor='#00D19F' secondcolor='#DAE7ED'>
					<DoughnutChart totalAmount={totalValue.chart1} data={chart1Data} options={DoughnutChartOptions} />
					<ChartlabelALT
						firstColorId={"#00D19F"}
						firstCaption={"Investor"}
						firstAmount={chartInfo?.investor}
						secondColorId={"#DAE7ED"}
						secondCaption={"Apprentice"}
						secondAmount={chartInfo?.apprentice}
						totalAmount={totalValue.chart1}
						customLabel={"user(s)"}
					/>
				</ChartCardContent>
			</CardLayout>

			<CardLayout type='A.F Type'>
				<ChartCardContent firstcolor='#00D19F' secondcolor='#DAE7ED'>
					<DoughnutChart totalAmount={totalValue.chart2} data={chart2Data} options={DoughnutChartOptions} />
					<ChartlabelALT
						firstColorId={"#006770"}
						firstCaption={"Sponsored"}
						firstAmount={chartInfo?.sponsored}
						secondColorId={"#DAE7ED"}
						secondCaption={"Quick"}
						secondAmount={chartInfo?.quick}
						totalAmount={totalValue.chart2}
						customLabel={"A.F"}
					/>
				</ChartCardContent>
			</CardLayout>
		</CardWrapper>
	);
};

export default HeaderCharts;
